export default (answered, total) => {
  if (typeof answered !== 'number' || typeof total !== 'number') {
    return 0;
  }

  if (answered > total) {
    return 100;
  }

  const division = answered / total;
  // A case when answered and total is equal to zero. This means there is no mapping yet for this cancer type
  if (Number.isNaN(division)) {
    return 0;
  }

  return division * 100;
};
